import { Injectable } from '@angular/core';
import { metaReportTabUrl, metaReportUrl } from '../sp-tab-pointer/di-report-url';

@Injectable({
  providedIn: 'root'
})
export class DiReportNavigatorService {

  openReportInDigitalIntelligence(projectId: number): void {
    window.location.href = metaReportUrl(projectId);
  }

  replaceWithDigitalIntelligenceSummary(projectId: number): void {
    window.location.replace(metaReportTabUrl(projectId, 'summary'));
  }

  openDigitalIntelligenceSummary(projectId: number): void {
    window.location.assign(metaReportTabUrl(projectId, 'summary'));
  }
}
